<template>
  <section>
    <!-- 로그인 전 -->
    <aside class="login-panel" v-if="!isLogin">
      <span class="login-panel__icon" aria-hidden="true">
        <img src="@/assets/img/img_login_key.png" alt="" />
      </span>
      <h3 class="login-panel__title">로그인 해주세요!</h3>
      <p class="login-panel__desc">
        취약점 제보 및 조치 <br />
        서비스 이용을 위해 로그인이 필요합니다.
      </p>
      <button type="button" class="btn btn--blue" @click="loginTo">
        로그인
      </button>
      <!-- 보조 링크 -->
      <nav class="login-panel__links" aria-label="도움 링크">
        <ul class="login-panel__link-list">
          <li class="login-panel__link-item">
            <a class="login-panel__link" @click="goToAuthPage('ID')"
              >아이디 찾기</a
            >
          </li>
          <li class="login-panel__link-item">
            <a class="login-panel__link" @click="goToAuthPage('PASSWORD')"
              >비밀번호 찾기</a
            >
          </li>
          <li class="login-panel__link-item">
            <a class="login-panel__link" @click="goToJoinPage">회원가입</a>
          </li>
        </ul>
      </nav>
    </aside>
    <!-- 로그인 -->
    <aside class="login-panel" v-if="isLogin && !isAccount">
      <form class="login-panel__form" action="#" method="post">
        <h3 class="login-panel__title">로그인 해주세요!</h3>
        <p class="login-panel__desc">
          취약점 제보 및 조치 <br />
          서비스 이용을 위해 로그인이 필요합니다.
        </p>
        <!-- 아이디 & 비밀번호 입력폼 -->
        <div>
          <!-- 아이디 -->
          <div class="login-panel__field">
            <label for="login-id" class="sr-only">아이디</label>
            <input
              id="login-id"
              class="login-panel__input"
              type="text"
              placeholder="아이디"
              aria-label="아이디"
              required
              v-model="loginInfo.id"
              autofocus
            />
          </div>
          <!-- 비밀번호 -->
          <div class="login-panel__field">
            <label for="login-pw" class="sr-only">비밀번호</label>
            <input
              id="login-pw"
              class="login-panel__input"
              type="password"
              placeholder="비밀번호"
              aria-label="비밀번호"
              required
              v-model="loginInfo.password"
              @keyup.enter="login"
            />
          </div>
        </div>
        <button
          type="button"
          class="btn btn--blue"
          @click="login"
          @keyup.enter="login"
        >
          로그인
        </button>
        <!-- 보조 링크 -->
        <nav class="login-panel__links" aria-label="도움 링크">
          <ul class="login-panel__link-list">
            <li class="login-panel__link-item">
              <a class="login-panel__link" @click="goToAuthPage('ID')"
                >아이디 찾기</a
              >
            </li>
            <li class="login-panel__link-item">
              <a class="login-panel__link" @click="goToAuthPage('PASSWORD')"
                >비밀번호 찾기</a
              >
            </li>
            <br />
            <li class="login-panel__link-item">
              <a class="login-panel__link" @click="goToJoinPage">회원가입</a>
            </li>
            <li class="login-panel__link-item">
              <a class="login-panel__link" @click="goToNonMemberPage()"
                >비회원 로그인</a
              >
            </li>
          </ul>
        </nav>
      </form>
    </aside>
    <!-- 로그인 후 -->
    <aside class="login-panel login-panel--signed" v-if="isAccount && isLogin">
      <h3 class="login-panel__greeting">
        <span class="name">{{ userId }}</span
        >님 반갑습니다.
      </h3>
      <ul class="login-panel__stats">
        <li class="login-panel__item">
          <router-link
            class="login-panel__item-link"
            :to="role === 'REPORT' ? '/report/records' : '/patch/records'"
          >
            <p class="login-panel__label">
              <span class="" aria-hidden="true">
                <img
                  src="@/assets/img/main/icon_report_send.svg"
                  class="light-only"
                />
                <img
                  src="@/assets/img/main/icon_report_send_dark.svg"
                  class="dark-only"
                />
              </span>
              {{ role === "REPORT" ? "취약점 신고 관리" : "취약점 패치 관리" }}
            </p>
            <div class="login-panel__value">
              <span class="login-panel__chevron" aria-hidden="true">
                <img src="@/assets/img/main/icon_chevron_right.svg" alt="" />
              </span>
            </div>
          </router-link>
        </li>
        <li class="login-panel__item">
          <router-link class="login-panel__item-link" to="security/scan">
            <p class="login-panel__label">
              <span aria-hidden="true">
                <img
                  src="@/assets/img/main/icon_pc_scan.svg"
                  alt=""
                  class="light-only"
                />
                <img
                  src="@/assets/img/main/icon_pc_scan_dark.svg"
                  alt=""
                  class="dark-only"
                />
              </span>
              내 PC 취약점 검사
            </p>
            <div class="login-panel__value">
              <span class="login-panel__chevron" aria-hidden="true">
                <img src="@/assets/img/main/icon_chevron_right.svg" alt="" />
              </span>
            </div>
          </router-link>
        </li>
        <li class="login-panel__item">
          <router-link class="login-panel__item-link" to="/member/myPage">
            <p class="login-panel__label">
              <span class="" aria-hidden="true">
                <img src="@/assets/img/main/icon_user.svg" class="light-only" />
                <img
                  src="@/assets/img/main/icon_user_dark.svg"
                  class="dark-only"
                />
              </span>
              마이페이지
            </p>
            <div class="login-panel__value">
              <span class="login-panel__chevron" aria-hidden="true">
                <img src="@/assets/img/main/icon_chevron_right.svg" alt="" />
              </span>
            </div>
          </router-link>
        </li>
      </ul>
      <button type="button" class="login-panel__logout" @click="logout">
        로그아웃
      </button>
    </aside>
  </section>
</template>

<script>
import { inject, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { deleteAllIndexedDBs } from "@/component/TempSave.js";
import dc from "@/component/DataChk.js";
import gt from "@/component/GetTokenValue.js";
import rsa from "@/component/RSAPublicKey.js";

export default {
  setup(props, { emit }) {
    const axios = inject("axios");
    const store = useStore();
    const router = useRouter();
    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");

    // data 정의
    const isLogin = ref(true);
    const isAccount = ref(false);
    const loginInfo = ref({ id: "", password: "" });
    const userId = ref(null);
    const role = ref("REPORT");

    // methods 정의
    const loginTo = () => {
      isLogin.value = true;
    };

    const getLoginInfo = () => {
      role.value = gt.getRole();
      userId.value = gt.getUser();
    };

    // 로그인
    const login = () => {
      if (!validateLoginInfo()) {
        return;
      }

      showLoading();

      const encrptyLoginInfo = {
        id: rsa.encryptData(loginInfo.value.id),
        password: rsa.encryptData(loginInfo.value.password),
      };

      axios
        .post("/core/pu/member/login", encrptyLoginInfo)
        .then((res) => {
          loginInfo.value.password = "";
          if (res.data.resType === "RES_OK") {
            isAccount.value = true;
            // getMemberCount();
            getLoginInfo();
            emit("role", gt.getRole());
          } else {
            const msg = res.data.resMsg.replace(/\\n/g, "\n");

            alert(msg);
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          hideLoading();
        });
    };

    // 로그아웃
    const resetLoginState = () => {
      deleteAllIndexedDBs();
      loginInfo.value = { id: "", password: "" };
      isLogin.value = true;
      isAccount.value = false;
    };

    const logout = async () => {
      if (!gt.hasToken()) {
        resetLoginState();
        return;
      }

      showLoading();
      try {
        const res = await axios.get("/core/pu/member/logout");
        if (res.data.resType === "RES_OK") {
          resetLoginState();
        } else {
          alert(res.data.resMsg);
        }
      } catch (error) {
        console.error(error);
      } finally {
        hideLoading();
      }
    };

    // 건수 조회
    // const getMemberCount = () => {
    //   axios
    //     .get(`/core/pu/member/count/get`)
    //     .then((res) => {
    //       if (res.data.resType === "RES_OK") {
    //         memberCount.value = res.data.resMsg;
    //       } else {
    //         alert(res.data.resMsg);
    //       }
    //     })
    //     .catch((error) => {
    //       console.error(error);
    //     });
    // };

    const validateLoginInfo = () => {
      if (!dc.nullChk(loginInfo.value.id)) {
        alert("로그인 아이디를 입력하세요");
        return false;
      }

      if (!dc.nullChk(loginInfo.value.password)) {
        alert("로그인 패스워드를 입력하세요");
        return false;
      }
      return true;
    };

    // 페이지 이동
    const goToAuthPage = (pageType) => {
      router.push({
        name: "findMemberInfo",
        query: {
          pageType,
        },
      });
    };
    const goToNonMemberPage = () => {
      router.push({ name: "nonMember" });
    };

    const goToJoinPage = () => {
      router.push({ name: "joinType" });
    };

    const signIn = () => {
      isAccount.value = true;
    };

    const getJwtFromCookie = () => {
      const user = gt.getUser();
      const role = gt.getRole();
      if (dc.nullChk(user) && ["REPORT", "PATCH"].includes(role)) {
        isAccount.value = true;
        isLogin.value = true;
        getLoginInfo();
        // getMemberCount();
        emit("role", role);
      }
    };

    // life cycle 정의
    onMounted(() => {
      rsa.getPublicKey();
      getJwtFromCookie();
    });

    // html에서 사용될 데이터 정의
    return {
      loginTo,
      signIn,
      logout,
      isAccount,
      isLogin,
      loginInfo,
      login,
      goToAuthPage,
      goToJoinPage,
      goToNonMemberPage,
      userId,
      role,
    };
  },
};
</script>

<style>
</style>